'use client';
import { Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { badge, filterBadge, focus } from '@mage-ui/styled-system/recipes';

export const FilterBadge = ({
  data,
  onClick,
  selectedItem,
  classNames,
  ...props
}) => {
  const formattedValue = data?.value
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/'/g, '');

  return (
    <div className={cx(filterBadge().root, 'group')} {...props}>
      <input
        className={cx(filterBadge().input, 'peer')}
        type='checkbox'
        id={data?.id || formattedValue}
        value={data?.value}
        aria-label={data?.label}
        name={data?.name}
        checked={selectedItem.includes(data?.value)}
        aria-checked={selectedItem.includes(data?.value)}
        onClick={onClick}
        onChange={onClick}
      />
      <label
        className={cx(
          badge({ status: 'neutral', size: 's' }),
          filterBadge().label,
          focus(),
        )}
        htmlFor={data?.id || formattedValue}
      >
        {data?.label}
        {selectedItem.includes(data?.value) && (
          <Icon
            name='cancel'
            classNames={{ root: filterBadge().icon }}
            aria-hidden='true'
          />
        )}
      </label>
    </div>
  );
};
